:host{display:flex;border:3px solid #da9c36;color:#000;padding:15px 20px;align-items:center;text-align:justify;flex-direction:row;gap:40px}
/*# sourceMappingURL=warning.component-CPAUUWNN.css.map */
